<div class="wrap" [ngClass]="'eur-label-align-' + secondaryCurrencyAlight">
  <div *ngIf="value" class="container">
    <img
      *ngIf="!noIcon"
      class="icon"
      [src]="'/assets/icon/price-label.svg'"
      alt="price"
    />
    <div class="price price-compact">
      <div class="start">{{ value.start }}</div>
      <div class="rest">
        {{ value.bigPart + value.splitter + value.end }}
      </div>
    </div>
    <!-- ALL PRICE LABELS MORPHED TO COMPACT VIEW WHILE EUR SHOULD BE SHOWN -->
    <!-- <div *ngIf="!isCompact" class="price price-big">
      <div class="start">{{ value.start }}</div>
      <div class="big-part">{{ value.bigPart }}</div>
      <div class="end">{{ value.splitter + value.end }}</div>
    </div> -->
  </div>
  <div class="price price-big eur-label" [class.with-icon]="!noIcon">
    <span *ngIf="secondaryCurrencyAlight === 'inline'" class="bracket">(</span>
    <div class="start">
      {{ "@common.currencies." + appCurrencies.BGN | translate }}
    </div>
    <div class="rest">
      {{ levoPrice }}
    </div>
    <span *ngIf="secondaryCurrencyAlight === 'inline'" class="bracket">)</span>
  </div>
</div>
